import { Component } from 'preact'
import $ from 'jquery'
import { t } from 'libs/translationsUtils/translations'
import tracker from '../../components/tracker/publish'
import { getCurrentPage } from '../common/index'
import Analytics from '../analytics/Analytics'

const eventTracker = () => {
  tracker.trackEvent('userevent', {
    type: 'Sidebar Widget Clicked',
    widget: 'solved topics',
    click_source: getCurrentPage()
  })

  if (getCurrentPage() === 'homepage') {
    Analytics({
      eventCategory: 'Homepage',
      eventAction: 'Widget clicked',
      eventLabel: {
        Type: 'Solved topics'
      }
    })
  }
}

class SolvedTopics extends Component {
  componentDidMount () {
    $.get('/widget/solvedTopics', {
      query: JSON.stringify(this.props.query)
    }, (topics) => {
      this.setState({ topics: topics })
    })
  }

  render (props, state) {
    if (!state.topics) return null
    return (
      <div className='box__content box__pad widget-solvedtopics'>
        { props.title ? <h3 className='widget-title'>{props.title}</h3> : '' }
        <ul className='list' onClick={eventTracker}>
          {
            state.topics.map((topic) => {
              return (
                <li>
                  <h6>
                    <a className='link link--topic' href={topic.url}>{topic.title}</a>
                    <span className='icon icon--round icon--checkmark text--success qa-icon-answered' />
                  </h6>
                  <a href={topic.lastPost.url} className='text--meta'>{topic.numberOfReplies} {t('Forum', 'Reply', { value: topic.numberOfReplies })}</a>
                </li>
              )
            })
          }
        </ul>
      </div>
    )
  }
}

export default SolvedTopics
